(function($){
    $(function(){        
        var $container = $('#products');
        
        /*function initIsotop(){
            
            $container = $('#products');

            $container.isotope({
                layoutMode: 'fitRows',
                itemSelector: '.product-block',
                getSortData: {
                    name: '[data-title]',
                    price: '[data-price] parseInt',
                    views: '[data-views] parseInt'
                },
                sortBy: 'name' 
            });

        }
        // Initialize isitope only after images are loaded
        $('#products').imagesLoaded().done(function(){
            initIsotop();
        });*/
		
        /*****************************************
        * infinite scroll on click of load more 
        * button and change text of load more button 
        * based on response
        *****************************************/

        $('ol.commentlist').infinitescroll({
                navSelector     : '.page-numbers', // selector for the paged navigation 
                nextSelector    : '.next.page-numbers', // selector for the NEXT link (to page 2)
                itemSelector    : '.comment', // selector for all items you'll retrieve
                loading: {
                        img: bego_i18n.loader_image,
                },
                behavior: 'twitter'
        },
        function(arrayOfNewElems){
                loadmorebuttonchnage();
        });
		
        function loadmorebuttonchnage(){
                var remianing_reviews = $("#load-more-comments").attr("remianing_reviews");
                var remianing_reviewsint = parseInt(remianing_reviews)-5;

                if(remianing_reviewsint < 1){
                        $("#load-more-comments").hide();
                }else{
                        var btn_txt = $("#load-more-comments").text();				
                        $("#load-more-comments").attr("remianing_reviews",remianing_reviewsint);
                        $("#load-more-comments").text(btn_txt.replace(remianing_reviews,remianing_reviewsint));
                }
        }

        $(document).on('click', '#load-more-comments', function () {
                $('ol.commentlist').infinitescroll('retrieve');	
                return false;
        });

        /**********************************************************/	
        
        // Initialize isitope only after images are loaded
        /*function initInfiniteScroll(){
            $container.infinitescroll({
                navSelector     : '.page-numbers', // selector for the paged navigation 
                nextSelector    : '.page-numbers a', // selector for the NEXT link (to page 2)
                itemSelector    : '.product-block', // selector for all items you'll retrieve
                loading: {
                    img: bego_i18n.loader_image,
                }
            },

            // Trigger Masonry as a callback
            function( newElements ) {
                    // hide new items while they are loading
                    var $newElems = $( newElements ).css({ opacity: 0 });
                    // ensure that images load before adding to masonry layout
                    $newElems.imagesLoaded(function(){
                            // show elems now they're ready
                            $newElems.animate({ opacity: 1 });
                            $container.isotope( 'appended', $newElems, true ); 
                            $('.equalheights').matchHeight(); 
                    }); 
            });  
        }
         
        initInfiniteScroll();*/
        
        /***********************************************************
         *
         * yith-wcan-ajax-filtered - when products are filtered
         * @location : yith-woocommerce-ajax-product-filter-premium/assets/yith-wcan-frontend.js
         *   
         **********************************************************/
        jQuery(document).on('yith-wcan-ajax-filtered', function() { 
            console.log("triggerd filtered");
            jQuery('#products').imagesLoaded().done(function(){
                // remove the old group
                jQuery('.equalheights').matchHeight({ remove: true });
                // apply matchHeight on the new selection, which includes the new element
                jQuery('.equalheights').matchHeight();
            });
	}); 
	  
	jQuery(document).on('yith-wcan-ajax-reset-filtered', function() { 
            // Re Initialize isotop & infiniteScroll function  
            jQuery('#products').imagesLoaded().done(function(){
                // remove the old group
                jQuery('.equalheights').matchHeight({ remove: true });
                // apply matchHeight on the new selection, which includes the new element
                jQuery('.equalheights').matchHeight();
            });
            //jQuery.fn.matchHeight._update();
            //initInfiniteScroll(); 
	});           
        
        $(document).on('click', '#product-sort #alphabetic-sort', function () {
            //$container.isotope({sortBy: 'name', sortAscending: true});
            window.location.href = current_page_url+"?orderby=title";
        }); 

        $(document).on('click', '#product-sort #price-sort', function () {
            //$container.isotope({sortBy: 'price', sortAscending: true});  
            window.location.href = current_page_url+"?orderby=price";
        });

        $(document).on('click', '#product-sort #popular-sort', function () {
            //$container.isotope({sortBy: 'views', sortAscending: false});
            window.location.href = current_page_url+"?orderby=popularity";
        });
        
    });
    
  })(jQuery);   